module.exports = __webpack_public_path__ + "img/ch09_07_驯蛇穿袜.842f0598.jpg";